import SendIcon from "@mui/icons-material/Send";
import TuneIcon from "@mui/icons-material/Tune";
import WebAssetIcon from "@mui/icons-material/WebAsset";
import WebAssetOffIcon from "@mui/icons-material/WebAssetOff";
import { IconButton, InputBase, Paper, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import { useCustomThemeContext } from "../lib/contexts/ThemeContext";
import { useChatSessionsContext } from "../lib/contexts/ChatSessionsContext";

interface InputAreaProps {
  currentMessage: string;
  disabled: boolean;
  handleSubmit: any;
  handleInputChange: any;
  handleChatFilterClick: any;
  isWebToolEnabled: boolean;
  handleWebToolToggle: () => void;
}

export default function InputArea(props: InputAreaProps) {
  const { custom } = useCustomThemeContext();
  const context = useChatSessionsContext();
  const { inputRef } = context;

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        marginTop: "1%",
        justifyContent: "center",
        alignContent: "center",
      }}
    >
      {/* Textfield section */}
      <Paper
        component="form"
        sx={{
          p: "2px 4px",
          display: "flex",
          alignItems: "flex-end",
          width: "90%",
          borderRadius: "30px",
          minHeight: "5vh",
        }}
        // calls handleSubmit function when user either hits "Enter" or clicks on the submit icon button
        onSubmit={props.handleSubmit}
      >
        <InputBase
          value={props.currentMessage}
          onChange={props.handleInputChange} // when user enters text, handleInputChange is called to update currentMessage
          multiline // allow the field to grow vertically as the question gets longer
          maxRows={8} // cap growth, then scroll within the field
          // Enter submits the question; Shift+Enter inserts a new line
          onKeyDown={(event) => {
            if (event.key === "Enter" && !event.shiftKey) {
              event.preventDefault();
              if (!props.disabled) {
                props.handleSubmit(event);
              }
            }
          }}
          sx={{ width: "100%", paddingLeft: "15px", py: "8px" }}
          placeholder="Send a message"
          inputProps={{ "aria-label": "Send a message" }}
          inputRef={inputRef} // Attach the ref to the InputBase
        />
        <Tooltip title="Metadata Filters">
          <IconButton
            sx={{ p: "2%" }}
            aria-label="directions"
            onClick={props.handleChatFilterClick}
            disabled={props.disabled}
          >
            <TuneIcon
              sx={{
                color: props.disabled
                  ? "rgba(0, 0, 0, 0.26)"
                  : custom.palette.secondary.light,
              }}
            />
          </IconButton>
        </Tooltip>
        <Tooltip title={props.isWebToolEnabled ? "Web Tool Enabled" : "Web Tool Disabled"}>
          <IconButton
            sx={{ p: "2%" }}
            aria-label="web tool toggle"
            onClick={props.handleWebToolToggle}
            disabled={props.disabled}
          >
            {props.isWebToolEnabled ? (
              <WebAssetIcon
                sx={{
                  color: props.disabled
                  ? "rgba(0, 0, 0, 0.26)"
                  : custom.palette.secondary.light,
                }}
              />
            ) : (
              <WebAssetOffIcon
                sx={{
                  color: props.disabled
                  ? "rgba(0, 0, 0, 0.26)"
                  : custom.palette.secondary.light,
                }}
              />
            )}
          </IconButton>
        </Tooltip>
        <Tooltip title="Send Message">
          <IconButton
            sx={{ p: "2%" }}
            aria-label="directions"
            type="submit"
            disabled={props.disabled}
          >
            <SendIcon
              sx={{
                color: props.disabled
                  ? "rgba(0, 0, 0, 0.26)"
                  : custom.palette.secondary.light,
              }}
            />
          </IconButton>
        </Tooltip>
      </Paper>
    </Box>
  );
}
